import { useParams } from 'react-router-dom';
import { HandBorneMicroorganisms } from '../microbiology/hand-borne-microorganisms';
import { HospitalInfections } from '../microbiology/hospital-infections';
import { DisinfectionAndWashing } from '../hand-disinfection-and-washing/disinfection-and-washing';
import { HandCare } from '../hand-disinfection-and-washing/hand-care';
import { HandHygieneAndMedicalGloves } from '../hand-disinfection-and-washing/hand-hygiene-and-medical-gloves';
import { PreparingYourHandsToWork } from '../hand-disinfection-and-washing/preparing-your-hands-to-work';
import { ProperHandDisinfection } from '../hand-disinfection-and-washing/proper-hand-disinfection';
import { ProperHandWashing } from '../hand-disinfection-and-washing/proper-hand-washing';
import { FiveMomentsHandHygiene } from '../moments-of-hand-hygiene-animations/five-moments-hand-hygiene';
import { Scenario1 } from '../moments-of-hand-hygiene-animations/scenario-1';
import { Scenario2 } from '../moments-of-hand-hygiene-animations/scenario-2';
import { Scenario3 } from '../moments-of-hand-hygiene-animations/scenario-3';
import { Scenario4 } from '../moments-of-hand-hygiene-animations/scenario-4';
import { HandHygieneQuiz } from '../quiz';

const topicComponentMap: Record<string, JSX.Element> = {
    'hospital-infections': <HospitalInfections />,
    'hand-borne-microorganisms': <HandBorneMicroorganisms />,
    'preparing-your-hands-to-work': <PreparingYourHandsToWork />,
    'proper-hand-disinfection': <ProperHandDisinfection />,
    'proper-hand-washing': <ProperHandWashing />,
    'disinfection-and-washing': <DisinfectionAndWashing />,
    'hand-care': <HandCare />,
    'hand-hygiene-and-medical-gloves': <HandHygieneAndMedicalGloves />,
    'moments-of-hand-hygiene': <FiveMomentsHandHygiene />,
    'scenario-1': <Scenario1 />,
    'scenario-2': <Scenario2 />,
    'scenario-3': <Scenario3 />,
    'scenario-4': <Scenario4 />,
    'quiz': <HandHygieneQuiz />,
};

export const OldHandHygieneTopic = () => {
    const { topicPath } = useParams<{ topicPath: string }>();
    return topicComponentMap[topicPath] ?? null;
};
